import React, { Component } from "react";
import styled from "styled-components";
import DemoForm from "./demoForm";
import axios from "axios";
import validate from "validate.js";

const FromContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  /* height: 100vh; */
  margin-bottom: 3rem;
  flex-direction: row;
  width: 100%;

  form {
    /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.08); */
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
      0 5px 15px 0 rgba(0, 0, 0, 0.08);
    border-radius: 5px;
    background: #ffffff;
    margin: 0 auto;
    padding: 40px;
    width: 500px;
    max-width: 90%;
    /* margin-top: -7rem; */
  }

  @media (max-width: 500px) {
    form {
      padding: 20px;
      width: 100%;
    }
  }
`;

class DemoCreator extends Component {
  state = {
    systemName: "",
    systemEmail: "",
    systemPassword: "",
    submitDisabled: false,
    systemValid: true,
    emailValid: true,
    passwordValid: true,
    gaCookie: "",
    utmCookie: "",
    utmMediumCookie: ""
  };

  componentDidMount() {
    function getCookie(name) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + name + "=");
      if (parts.length === 2)
        return parts
          .pop()
          .split(";")
          .shift();
    }

    const gaCookie = getCookie("_ga") || "";
    const utmCookie = getCookie("utm_source") || "";
    const utmMediumCookie = getCookie("utm_medium") || "";
    this.setState({
      gaCookie,
      utmCookie,
      utmMediumCookie
    });
  }

  checkIsSystemValid = e => {
    if (e.target.value.length > 0) {
      const params = new URLSearchParams();
      params.append("system_name", e.target.value);

      const url = "https://administracja.questy-cloud.pl/";
      return axios
        .post(url + "checkName.php", params)
        .then(response => {
          const { data } = response;
          if (data === 1) {
            this.setState({
              systemValid: true,
              submitDisabled: this.props.type === "login" ? false : true
            });
            return true;
          } else {
            this.setState({
              systemValid: false,
              submitDisabled: this.props.type === "login" ? true : false
            });
            return false;
          }
        })
        .catch(err => {
          alert("Błąd połączenia");
          return false;
        });
    } else {
      this.setState({
        systemValid: false,
        submitDisabled: true
      });
    }
  };

  handleFieldChange = e => {
    const { name, value } = e.target;

    if (name === "system-name" || name === "systemName") {
      const isValid = validate(
        { systemName: value },
        {
          systemName: {
            format: {
              pattern: "[a-z0-9]+"
            }
          }
        }
      );

      if (isValid === undefined || (isValid && e.target.value === "")) {
        this.setState({ systemName: value });
      } else {
        e.preventDefault();
      }
    } else if (name === "system-email" || name === "security_username") {
      this.setState({ systemEmail: value });
    } else if (name === "system-password" || name === "security_password") {
      this.setState({ systemPassword: value });
    }

    if (name === "system-email") {
      const emailValid = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i.test(value);
      this.setState({
        emailValid
      });
    }
    if (name === "system-password") {
      const passwordValid = value.length >= 8;
      this.setState({
        passwordValid
      });
    }
  };

  render() {
    let url;
    this.props.type === "login"
      ? (url = `https://${
          this.state.systemName
        }.questy-cloud.pl/security/login/`)
      : (url = `https://administracja.questy-cloud.pl/addNew.php`);
    return (
      <FromContainer>
        <DemoForm
          type={this.props.type}
          checkIsSystemValid={this.checkIsSystemValid}
          systemValid={this.state.systemValid}
          emailValid={this.state.emailValid}
          passwordValid={this.state.passwordValid}
          logo={this.props.logo}
          header={this.props.header}
          handleFieldChange={this.handleFieldChange}
          gaCookie={this.state.gaCookie}
          utmCookie={this.state.utmCookie}
          utmMediumCookie={this.state.utmMediumCookie}
          // submitDisabled={this.state.submitDisabled}
          submitDisabled={
            !(
              this.state.emailValid &&
              this.state.passwordValid &&
              !this.state.systemValid
            )
          }
          submitButtonText={this.props.submitButtonText}
          systemNameValue={this.state.systemName}
          systemLoginValue={this.state.systemEmail}
          systemPasswordValue={this.state.systemPassword}
          url={url}
          systemType={this.props.systemType}
        />
      </FromContainer>
    );
  }
}

export default DemoCreator;
